import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Button"], {
        "data-sidebar": "trigger",
        "data-slot": "sidebar-trigger",
        variant: "ghost",
        size: "icon",
        class: _normalizeClass($setup.cn('h-7 w-7', $setup.props.class)),
        onClick: $setup.toggleSidebar
    }, {
        default: _withCtx(() => [
            _createVNode($setup["PanelLeft"]),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Toggle Sidebar", -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onClick"]));
}
